import axios from "axios";
import Storage from "./Storage";

// When using the proxy configuration, we don't need a base URL
const BASE_URL = "";

class Request {
  constructor(endpoint, parameters = {}) {
    // Default request options for axios
    let options = {
      method: "GET",
      url: BASE_URL + endpoint,
      headers: { "Access-Control-Allow-Origin": "*" },
    };

    if (Storage.isLoggedIn()) {
      options["headers"] = {
        ...options["headers"],
        Authorization: "Bearer " + Storage.getToken(),
      };
    }

    // Only pass method if undefined, since it is assumed to be GET
    if (parameters["method"] !== undefined) {
      options["method"] = parameters["method"];
      if (parameters["method"] === "POST") {
        options["headers"] = {
          ...options["headers"],
          "content-type": "application/json",
        };
      }
    }

    if (parameters["responseType"] !== undefined) {
      options["responseType"] = parameters["responseType"];
    }

    // Add request data
    options["data"] = parameters["data"];

    // Pass request body and URL parameters
    options["params"] = parameters["params"];

    options["headers"] = { ...options["headers"], ...parameters["headers"] };

    // Perform the request
    axios(options)
      .then((response) => {
        if (typeof this.then !== "undefined") {
          this.then(response);
        } else {
          return this;
        }
      })
      .catch((error) => {
        console.log(error);
        if (
          error.response &&
          (error.response.status === 401 || error.response.status === 422)
        ) {
          console.log("bigger bruh");
          Storage.logOut();
          window.location.reload();
        }
        if (typeof this.catch !== "undefined") {
          console.log(error);
          this.catch(error);
        } else {
          console.log("Call to " + endpoint + " FAILED");
          console.log(error);
          return this;
        }
      });
  }

  catch(callback) {
    this.catch = callback;
    return this;
  }

  then(callback) {
    this.then = callback;
    return this;
  }
}

export default Request;



// WEBPACK FOOTER //
// ./src/components/utils/Request.js